import React, { useEffect, useRef, useState } from "react";
import logo from "../Images/Group 1171279193 (1).png";
import { NavLink, useLocation } from "react-router-dom";
import icon from "../Images/Icon.png";
import HomeService from "../Services/HomeService";
import { toast } from "react-toastify";
const Footer = () => {
  const [hello, setHello] = useState("");
  const location = useLocation();
  // const [modal, setmodal] = useState(false);
  const [modal, setmodal] = useState(false);
  const handleClick = () => {
    if (modal) {
      setmodal(false);
    } else {
      setmodal(true);
    }
  };
  const [hotClientForm, setHotClientForm] = useState({
    userName: "",
    email: "",
    phone: "",
    city: "", //city id
    clientInHand: "",
  });
  const userNameRef = useRef("");
  const emailRef = useRef("");
  const phoneRef = useRef("");
  //const cityRef = useRef("");
  const clientInHandRef = useRef("");

  useEffect(() => {
    if (userNameRef.current) {
      userNameRef.current.focus();
    }
  }, [hotClientForm.userName]);
  useEffect(() => {
    if (emailRef.current) {
      emailRef.current.focus();
    }
  }, [hotClientForm.email]);
  useEffect(() => {
    if (phoneRef.current) {
      phoneRef.current.focus();
    }
  }, [hotClientForm.phone]);

  useEffect(() => {
    if (clientInHandRef.current) {
      clientInHandRef.current.focus();
    }
  }, [hotClientForm.clientInHand]);

  const [getCitiesForUser, setGetCitiesForUser] = useState([]);

  const fetchCitiesForUser = async () => {
    try {
      const res = await HomeService.getCitiesForUser();

      setGetCitiesForUser(res.data);
    } catch (error) {
      console.error("error in fetching City Details", error);
      toast.error("Error Fetching City Details!");
    }
  };

  useEffect(() => {
    fetchCitiesForUser();
  }, []);

  const handleChange = (e) => {
    // setHotClientForm({ ...hotClientForm, [e.target.name]: e.target.value });
    setHotClientForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await HomeService.addHotClient(hotClientForm);
      if (res?.status) {
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log("error while adding hot client", error);
    }
    setHotClientForm({
      userName: "",
      email: "",
      phone: "",
      city: "",
      clientInHand: "",
    });
  };

  const Modal = () => {
    return (
      <>
        <div className="modal_wrapper5625863166">
          <div className="modal_div8985">
            <i
              class="fa-regular fa-circle-xmark"
              onClick={() => {
                setmodal(false);
                setHotClientForm({
                  userName: "",
                  email: "",
                  phone: "",
                  city: "",
                  clientInHand: "",
                });
              }}
            ></i>
            <div className="form_wrapper">
              <form
                className="form_main5135642"
                onSubmit={(e) => {
                  handleFormSubmit(e);
                }}
              >
                {/* <div className="form_input565852">
                  <p>hello</p>
                  <input
                    value={hello}
                    type="text"
                    placeholder="Enter your name"
                    name="userName"
                    onChange={(e) => setHello(e.target.value)}
                  />
                </div> */}

                <div className="form_input565852">
                  <p>Name</p>
                  <input
                    ref={userNameRef}
                    value={hotClientForm.userName}
                    type="text"
                    placeholder="Enter your name"
                    name="userName"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>

                <div className="form_input565852">
                  <p>Email </p>
                  <input
                    ref={emailRef}
                    value={hotClientForm.email}
                    type="email"
                    placeholder="Enter your email"
                    name="email"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>

                <div className="form_input565852">
                  <p>Mobile No </p>
                  <input
                    ref={phoneRef}
                    value={hotClientForm.phone}
                    type="text"
                    placeholder="Enter your mobile no"
                    name="phone"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>

                <div className="form_input565852">
                  <p>City</p>
                  <select
                    value={hotClientForm.city}
                    name="city"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  >
                    <option value="">-----Select City-----</option>
                    {getCitiesForUser.map((city, i) => {
                      return (
                        <option key={i} value={city._id}>
                          {city.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="form_input565852">
                  <p>Clients in hand</p>
                  <input
                    ref={clientInHandRef}
                    value={hotClientForm.clientInHand}
                    type="text"
                    name="clientInHand"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>

                <button className="submit_btn_modal" type="submit">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {modal && <Modal />}
      {/* {<Modal show={modal} onClose={() => setmodal(false)} />} */}
      <div className="uni_wrapper">
        <div className={"uni_container"}>
          <div className="footer_div_main">
            <div
              // style={
              //   location.pathname == "/communitylist"
              //     ? {
              //         width: "100%",
              //         maxWidth: "94%",
              //         minWidth: "94%",
              //       }
              //     : {}
              // }
              className={
                location.pathname == "/propertylist"
                  ? "footer_new_class"
                  : location.pathname == "/communitylist"
                  ? "footer_new_class"
                  : "footer_div_wrapper"
              }
            >
              <div className="footer_div_1">
                <div className="footer_logo_div">
                  <img src={logo}></img>
                </div>
                <p className="footer_para">
                  In publishing and graphic design, Lorem ipsum is a placeholder
                  text commonly used to demonstrate the visual form
                </p>

                <div className="follow_div">
                  <p className="follow_para">Follow Us On</p>
                  <div className="follow_us_icon_div">
                    <div className="follow_us_icon_img">
                      <i class="fa-brands fa-facebook-f"></i>
                    </div>
                    <div className="follow_us_icon_img">
                      <i class="fa-brands fa-x-twitter"></i>
                    </div>
                    <div className="follow_us_icon_img">
                      <i class="fa-brands fa-instagram"></i>
                    </div>
                    <div className="follow_us_icon_img">
                      <i class="fa-brands fa-linkedin-in"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  location.pathname == "/propertylist"
                    ? "footer_links_new_wrapper"
                    : location.pathname == "/communitylist"
                    ? "footer_links_new_wrapper"
                    : "footer_links_wrapper"
                }
              >
                <div className="footer_div_2">
                  <p className="our_company_para">Our Company</p>
                  <div
                    className="mt-3"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      rowGap: "15px",
                    }}
                  >
                    <NavLink to="/" className="our_company_links" style={{textDecoration:"none"}}>Home</NavLink>
                    <NavLink to="/propertylist" className="our_company_links" style={{textDecoration:"none"}}>Properties</NavLink>
                    <NavLink to="/communitylist" className="our_company_links" style={{textDecoration:"none"}}>Community</NavLink>
                    <NavLink to="/profile" className="our_company_links" style={{textDecoration:"none"}}>Profile</NavLink>
                    <NavLink to="/career" className="our_company_links" style={{textDecoration:"none"}}>Career</NavLink>
                  </div>
                </div>
                {/* <div className='footer_div_2'>
         <p className='our_company_para'>Quick Links</p>
          <div className='mt-3' style={{display:'flex',flexDirection:'column',rowGap:'15px'}}>
            <p className='our_company_links'>Home</p>
            <p className='our_company_links'>Product</p>
            <p className='our_company_links'>Support</p>
            <p className='our_company_links'>About</p>
          </div>
         </div> */}
                <div className="footer_div_3">
                  <p className="our_company_para">Contact</p>
                  <div
                    className="mt-3"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      rowGap: "15px",
                    }}
                  >
                    <div>
                      <p className="our_company_address">Address</p>
                      <p className="our_company_links">Noida Sec. 2</p>
                    </div>
                    <div>
                      <p className="our_company_address">Email</p>
                      <p className="our_company_links">winners@gmail.com</p>
                    </div>
                    <div>
                      <p className="our_company_links">Phone</p>
                      <p className="our_company_links">+91-9834737373</p>
                    </div>
                  </div>
                </div>

                <div className="footer_div_4 d-none">
                  <p className="our_company_para">Get the latest information</p>
                  <div className="footer_form_field">
                    <input placeholder="Enter Email Address" />
                    <div className="footer_div_send">
                      <img src={icon} />
                    </div>
                  </div>
                </div>

                <div className="footer_div_4">
                  <p className="our_company_para">Send your requirements</p>
                  <button
                    onClick={() => {
                      handleClick();
                    }}
                  >
                    Click Here
                  </button>
                </div>
              </div>
            </div>
            <div style={{ borderTop: "1px solid rgba(255, 255, 255, 0.2)" }}>
              <div
                className={
                  location.pathname == "/propertylist"
                    ? "footer_div_new_copyright_class"
                    : location.pathname == "/communitylist"
                    ? "footer_div_new_copyright_class"
                    : "footer_div_copyright"
                }
              >
                <div>
                  <p className="copy_right_winners">Copyright ©2024 winners</p>
                </div>
                <div>
                  <p className="copy_right_winners">
                    Privacy Policy | Terms and Conditions
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
